import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { Typography } from "@mui/material";

// Format attribute names: replace _ with space and capitalize each word
function formatAttributeName(name) {
  if (typeof name !== 'string') return name;

  if (name.includes('_')) {
    return name
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  return name;
}

export default function BasicList({ title, data, render, className }) {
  return (
    <Box sx={{ width: "100%" }}>
      <List
        subheader={<Typography variant="h6">{title}</Typography>}
        dense
        sx={{ paddingBottom: 0 }}
        className={className}
      >
        {data.map((item, index) => {
          // Format item if it's an object with a name property
          const formattedItem = typeof item === 'object' && item.name
            ? { ...item, name: formatAttributeName(item.name) }
            : formatAttributeName(item);

          return (
            <div
              key={index}
              className={`${index === 0 ? "mt-2 list-item" : "list-item"}`}
            >
              {render(formattedItem, index)}
            </div>
          );
        })}
      </List>
    </Box>
  );
}
